import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "matrix_details"
};
const _hoisted_2 = {
  class: "base_details_content"
};
const _hoisted_3 = {
  class: "content"
};

const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "基本信息", -1);

const _hoisted_5 = {
  class: "base_details_content_second"
};

const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "法人信息", -1);

const _hoisted_7 = {
  class: "base_details_content_second"
};

const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "base_details_title"
}, "售后信息", -1);

const _hoisted_9 = {
  class: "base_details_content_second"
};
import UploadVideo from "@com/upload/UploadVideo.vue";
import BackTitleView from "@com/BackTitleView.vue";
import UploadSinglePicture from "@com/upload/UploadSinglePicture.vue";
import UploadPicture from "@com/upload/UploadPicture.vue";
import MapSelectAddress from "@com/MapSelectAddress.vue";
import { ref, reactive } from "vue";
import $ from "@util/base";
import { $msg } from "@ui/msg";
import useRoute from "@util/router";
import api from "@api/base";
export default {
  __name: 'BaseDetails',

  setup(__props) {
    const route = useRoute();
    const urlQuery = route.query();
    var readOnly = false;
    var title = "基地详情";
    $.handleCRU(urlQuery.type, {
      show: () => {
        readOnly = true;
        title = "基地详情";
        getData();
      },
      add: () => {
        title = "新增基地";
      },
      modify: () => {
        title = "修改基地";
        getData();
      }
    });

    function getData() {
      api.details(route.query().code, val => {
        form.value = val;
      });
    }

    const formRef = ref("");
    const form = ref({
      name: "",
      address: "",
      shopLevel: null,
      picList: [],
      descList: [],
      lat: null,
      lng: null,
      identityCardImg: "",
      businessLicenseImg: "",
      businessCertificateImg: "",
      bankAccountImg: "",
      returnRecipientName: "",
      returnPhoneNumber: "",
      returnAddress: ""
    });
    const rules = {
      name: [{
        required: true,
        message: "请输入基地名称",
        trigger: "blur"
      }],
      shopLevel: [{
        required: true,
        message: "请选择基地级别",
        trigger: "blur"
      }],
      address: [{
        required: true,
        message: "请输入基地地址",
        trigger: "blur"
      }],
      picList: [{
        required: true,
        type: "array",
        message: "请上传基地封面",
        trigger: "change"
      }],
      descList: [{
        required: true,
        type: "array",
        message: "请上传基地简介",
        trigger: "change"
      }],
      identityCardImg: [{
        required: true,
        message: "请上传法人身份证",
        trigger: "blur"
      }],
      businessLicenseImg: [{
        required: true,
        message: "请上传营业执照",
        trigger: "blur"
      }],
      businessCertificateImg: [{
        required: true,
        message: "请上传经营许可证",
        trigger: "blur"
      }],
      bankAccountImg: [{
        required: true,
        message: "请上传开户行信息",
        trigger: "blur"
      }],
      returnRecipientName: [{
        required: true,
        message: "请输入收货人姓名",
        trigger: "blur"
      }],
      returnPhoneNumber: [{
        required: true,
        message: "请输入收货人电话",
        trigger: "blur"
      }],
      returnAddress: [{
        required: true,
        message: "请输入收货地址",
        trigger: "blur"
      }]
    };

    function selectAddress(data) {
      form.value.address = data.address;
      form.value.lat = data.lat + "";
      form.value.lng = data.lng + "";
    }

    const checkForm = () => {
      if (!formRef.value) return;
      formRef.value.validate(valid => {
        if (valid) {
          $.handleCRU(route.query().type, {
            add: () => {
              addData();
            },
            modify: () => {
              modifyData();
            }
          });
        } else {
          return false;
        }
      });
    };

    function addData() {
      api.add(form.value, () => {
        $msg.succ("添加成功");
        back();
      });
    }

    function modifyData() {
      api.update(route.query().code, form.value, () => {
        $msg.succ("修改成功");
        back();
      });
    }

    function back() {
      route.go(-1);
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_radio = _resolveComponent("el-radio");

      const _component_el_radio_group = _resolveComponent("el-radio-group");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_footer = _resolveComponent("el-footer");

      const _component_el_container = _resolveComponent("el-container");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, {
        class: "base_details_container"
      }, {
        default: _withCtx(() => [_createVNode(BackTitleView, {
          title: _unref(title)
        }, null, 8, ["title"]), _createVNode(_component_el_main, null, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            rules: rules,
            disabled: _unref(readOnly),
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "基地名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.name = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "基地级别",
              prop: "shopLevel"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: form.value.shopLevel,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.shopLevel = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: "1040001"
                }, {
                  default: _withCtx(() => [_createTextVNode("总店")]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "1040002"
                }, {
                  default: _withCtx(() => [_createTextVNode("分店")]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "基地地址",
              prop: "address"
            }, {
              default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
                modelValue: form.value.address,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.address = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"]), _createVNode(MapSelectAddress, {
                class: "selectMap",
                position: [form.value.lng, form.value.lat],
                onSelect: selectAddress,
                disabled: _unref(readOnly)
              }, null, 8, ["position", "disabled"])])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "基地封面",
              prop: "picList"
            }, {
              default: _withCtx(() => [_createVNode(UploadPicture, {
                modelValue: form.value.picList,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.picList = $event),
                limit: 3,
                disabled: _unref(readOnly),
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "disabled", "fileSize"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "基地视频",
              prop: "videoList"
            }, {
              default: _withCtx(() => [_createVNode(UploadVideo, {
                modelValue: form.value.videoList,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.videoList = $event),
                limit: 1,
                fileSize: _unref($).videoFileSize(),
                disabled: _unref(readOnly)
              }, null, 8, ["modelValue", "fileSize", "disabled"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "基地简介",
              prop: "descList"
            }, {
              default: _withCtx(() => [_createVNode(UploadPicture, {
                modelValue: form.value.descList,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.descList = $event),
                limit: 50,
                disabled: _unref(readOnly),
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "disabled", "fileSize"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "disabled"])]), _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            rules: rules,
            disabled: _unref(readOnly),
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "法人身份证",
              prop: "identityCardImg"
            }, {
              default: _withCtx(() => [_createVNode(UploadSinglePicture, {
                modelValue: form.value.identityCardImg,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.identityCardImg = $event),
                disabled: _unref(readOnly),
                width: 120,
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "disabled", "fileSize"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "营业执照",
              prop: "businessLicenseImg"
            }, {
              default: _withCtx(() => [_createVNode(UploadSinglePicture, {
                modelValue: form.value.businessLicenseImg,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.businessLicenseImg = $event),
                disabled: _unref(readOnly),
                width: 120,
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "disabled", "fileSize"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "经营许可证",
              prop: "businessCertificateImg"
            }, {
              default: _withCtx(() => [_createVNode(UploadSinglePicture, {
                modelValue: form.value.businessCertificateImg,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.businessCertificateImg = $event),
                disabled: _unref(readOnly),
                width: 120,
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "disabled", "fileSize"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "开户行信息",
              prop: "bankAccountImg"
            }, {
              default: _withCtx(() => [_createVNode(UploadSinglePicture, {
                modelValue: form.value.bankAccountImg,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.bankAccountImg = $event),
                disabled: _unref(readOnly),
                width: 120,
                fileSize: _unref($).imgFileSize()
              }, null, 8, ["modelValue", "disabled", "fileSize"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "disabled"])]), _hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            model: form.value,
            rules: rules,
            disabled: _unref(readOnly),
            "label-width": "100px",
            class: "base_details_form"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "收货人姓名",
              prop: "returnRecipientName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.returnRecipientName,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => form.value.returnRecipientName = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "收货人电话",
              prop: "returnPhoneNumber"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.returnPhoneNumber,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => form.value.returnPhoneNumber = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(_component_el_form_item, {
              label: "收货地址",
              prop: "returnAddress"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.returnAddress,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => form.value.returnAddress = $event),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model", "disabled"])])])])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_footer, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: back
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_el_button, {
            onClick: checkForm,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("保存")]),
            _: 1
          })]),
          _: 1
        }, 512), [[_vShow, !_unref(readOnly)]])]),
        _: 1
      })]);
    };
  }

};